'use client';

import { useEffect, useState } from 'react';

/**
 * Switch globale (admin settings) per disabilitare il flow di prenotazione su
 * mobile. Quando attivo, mobile mostra modale che chiede di passare al desktop.
 * Usato come kill-switch durante incident/QA del flow mobile.
 */
export function useMobileBookingsDisabled(): { disabled: boolean; loading: boolean } {
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const API_URL = process.env.NEXT_PUBLIC_API_URL || '/api';
    fetch(`${API_URL}/settings/public/mobile-bookings`)
      .then(r => r.json())
      .then((data) => {
        if (data?.success && typeof data.data?.disabled === 'boolean') {
          setDisabled(data.data.disabled);
        }
      })
      .catch(() => { /* ignore */ })
      .finally(() => setLoading(false));
  }, []);

  return { disabled, loading };
}
